import api from "../libs/api";
import designation from "./designation";
import equipments from "./equipments";
import subscriber from "./subscriber";

export default {
  
lookups: (lookupName = null) => {
  return new Promise((resolve, reject) => {
    api()
      .get(`/lookups`, { params: { lookup: lookupName } })
      .then(({ status, data }) => {
        if (status === 200) {
          // your controller returns { data: [...], ... }
          const records = data.data || [];
          // find exact lookup by name (if provided)
          const selected =
            lookupName && records.length
              ? records.find((item) => item.lookup === lookupName)
              : null;
          resolve(selected ? selected.data : records);
        } else throw new Error(`Failed with status: ${status}`);
      })
      .catch((error) => reject(error));
  });
},

departments: () => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/get-all-departments`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },
  cost_centers: () => {
      return new Promise((resolve, reject) => {
          api()
              .get(`/get-all-cost-centers`)
              .then(({ status, data }) => {
                  if (status === 200) resolve(data.data);
                  throw new Error(`Failed with status: ${status}`);
              })
              .catch(error => reject(error));
      });
    },
    users: (query = "?all") => {
      return new Promise((resolve, reject) => {
        api()
          .get(`/users?all`)
          .then(({ status, data }) => {
            if (status === 200) resolve(data.data);
            throw new Error(`Faileds with status: ${status}`);
          })
          .catch((error) => reject(error));
      });
    },
    projects: (searchQuery) => {
      return new Promise((resolve, reject) => {
        const params = {
          search: searchQuery,
        };
          api()
              .get(`/projects`,{params})
              .then(({ status, data }) => {
                  if (status === 200) resolve(data.data);
                  throw new Error(`Failed with status: ${status}`);
              })
              .catch(error => reject(error));
      });
  },
  sections: (searchQuery) => {
    return new Promise((resolve, reject) => {
        const params = {
            search: searchQuery,
        };
        api()
            .get(`/sections`,{params})
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  categories: (page = 1, itemsPerPage = 150,searchQuery) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/software-categories`, {
          params: {
            page: page,
            per_page: itemsPerPage,
            search: searchQuery,
          },
        })
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },
  designations: () => {
    return new Promise((resolve, reject) => {
        api()
            .get(`/get-all-designations`)
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  locations: () => {
    return new Promise((resolve, reject) => {
        api()
            .get(`/get-all-locations`)
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  equipments: () => {
    return new Promise((resolve, reject) => {
        api()
            .get(`/get-all-equipments`)
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  forms: () => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/forms/?all`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
  subscribers: () => {
    return new Promise((resolve, reject) => {
        api()
            .get(`/subscribers`)
            .then(({ status, data }) => {
                if (status === 200) resolve(data.data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  approvers: (page, itemsPerPage) => {
    console.log(page, itemsPerPage)
    return new Promise((resolve, reject) => {
      const params = {
        page: page,
        per_page: itemsPerPage,
      };
        api()
            .get(`/approvers`, { params })
            .then(({ status, data }) => {
                if (status === 200) resolve(data);
                throw new Error(`Failed with status: ${status}`);
            })
            .catch(error => reject(error));
    });
  },
  makes: (page = 1, itemsPerPage = 15) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/makes`, {
          params: {
            page: page,
            per_page: itemsPerPage,
          },
        })
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },
  companies: (page, itemsPerPage, searchQuery) => {
    return new Promise((resolve, reject) => {
      const params = {
        page: page,
        itemsPerPage: itemsPerPage,
        search: searchQuery,
      };
  
      api()
        .get('/companies', { params })
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },
 services: (page = 1, itemsPerPage = 15) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/services`, {
          params: {
            page: page,
            per_page: itemsPerPage,
          },
        })
        .then(({ status, data }) => {
          if (status === 200) resolve(data.data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch((error) => reject(error));
    });
  },
};
